import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const multiSwitchGroupRootFn = /* @__PURE__ */ createRecipe('multi-switch-group-root', {}, [])

const multiSwitchGroupRootVariantMap = {}

const multiSwitchGroupRootVariantKeys = Object.keys(multiSwitchGroupRootVariantMap)

export const multiSwitchGroupRoot = /* @__PURE__ */ Object.assign(memo(multiSwitchGroupRootFn.recipeFn), {
  __recipe__: true,
  __name__: 'multiSwitchGroupRoot',
  __getCompoundVariantCss__: multiSwitchGroupRootFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: multiSwitchGroupRootVariantKeys,
  variantMap: multiSwitchGroupRootVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, multiSwitchGroupRootVariantKeys)
  },
  getVariantProps: multiSwitchGroupRootFn.getVariantProps,
})